import { render, staticRenderFns } from "./PlaceholderPanel.vue?vue&type=template&id=690fb10f&scoped=true&"
import script from "./PlaceholderPanel.vue?vue&type=script&lang=js&"
export * from "./PlaceholderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690fb10f",
  null
  
)

export default component.exports